import React from "react";
import "./App.css";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Portfolio from "./components/Portfolio";
import Differentials from "./components/Differentials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Portfolio />
      <Differentials />
      <Contact />
      <Footer />
      <WhatsAppButton />
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
